// removed by extract-text-webpack-plugin
module.exports = {"valignBottom":"FlexColumn__valignBottom___Rh75z","alignRight":"FlexColumn__alignRight___8-77G","noPrint":"FlexColumn__noPrint___3bBgp","growSM":"FlexColumn__growSM___2Av8a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/FlexColumn/FlexColumn.scss
// module id = 541
// module chunks = 0